import { useState, useEffect } from "react";

import { addCommas } from "@persian-tools/persian-tools";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import ReactTooltip from "react-tooltip";
import ReportWallet from "components/FinancialSuperAdmin/ReportWalletModal";
import Pagination from "rc-pagination";
import Swal from "sweetalert2";

import { BsXCircle } from "react-icons/bs";
import { TbReportSearch } from "react-icons/tb";
import { FiEdit } from "react-icons/fi";
import { CgUnblock } from "react-icons/cg";
import { MdBlock } from "react-icons/md";
export default function WalletCard({
  WalletCardData,
  setSelectedItem,
  stopHandler,
  unblockHandler,
}) {
  const convertTimestampToDate = (timeStamp) => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian,
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };
  const [currentPage, setCurrentPage] = useState(1);

  const [walletId, setWalletId] = useState("");
  const [walletUid, setWalletUid] = useState("");

  const [activeWallet, setActiveWallet] = useState();
  // useEffect(() => {
  //   setActiveWallet(WalletCardData.main_status);
  //   setWalletId(WalletCardData.id);
  // }, []);
  // const stopHandler = () => {
  //   setSelectedItem(item.suppliers__id);
  //   // setSelectedItem(index);
  //   // console.log(index);
  // };
  return (
    <>
      {WalletCardData != undefined ? (
        <div>
          <ReportWallet walletId={walletId}></ReportWallet>

          {WalletCardData?.slice(
            (currentPage - 1) * 5,
            (currentPage - 1) * 5 + 5
          ).map((value) => {
            return (
              <CardWallet
                name={value.fullname}
                date={convertTimestampToDate(value.mtm)}
                inventory={value.current_inventory}
                input={value.total_deposit}
                output={value.total_withdraw}
                type={value.type}
                main_status={value.main_status}
                title={value.title}
                mobile={value.mobile}
                walletId={value.wallets__id}
                setWalletId={setWalletId}
                setWalletUid={setWalletUid}
                walletUid={value.uid}
                unblockHandler={unblockHandler}
                stopHandler={stopHandler}
              />
            );
          })}
        </div>
      ) : (
        "ولتی وجود ندارد"
      )}
      <div className="d-flex justify-content-center mt-4">
        <div>
          <Pagination
            total={WalletCardData.length}
            pageSize={5}
            current={currentPage}
            onChange={(newPage) => {
              setCurrentPage(newPage);
            }}
          ></Pagination>
        </div>
      </div>
    </>
  );
}

function CardWallet({
  name,
  date,
  inventory,
  input,
  output,
  type,
  main_status,
  title,
  mobile,
  setWalletId,
  walletId,
  setWalletUid,
  walletUid,
  activeWallet,
  setActiveWallet,
  stopHandler,
  unblockHandler,
}) {
  return (
    <div
      className={`d-flex flex-wrap container-wallet mx-2 my-3 text-center ${
        main_status == "0" ? "bg-active" : "bg-disable"
      }`}
    >
      <div className="contain-wallet" style={{ width: "20%" }}>
        {type == "0" ? (
          <>
            <div className="title ">نام کاربر</div>

            <div className="txt">{name}</div>
          </>
        ) : (
          <>
            <div className="title ">نام فروشگاه</div>
            <div className="txt">{name}</div>
            {/* {name != null || name != "" ? { name } : "-"} */}
          </>
        )}
      </div>
      <div className="contain-wallet" style={{ width: "15%" }}>
        <div className="title">تاریخ ساخت</div>
        <div className="txt">{date}</div>
      </div>
      <div className="contain-wallet" style={{ width: "13%" }}>
        <div className="title">موبایل </div>
        <div className="txt">{mobile}</div>
      </div>
      <div className="contain-wallet" style={{ width: "14%" }}>
        <div className="title">موجودی</div>
        <div className="txt">
          {inventory != "" ? addCommas(inventory) : "0"}
        </div>
      </div>
      <div className="contain-wallet" style={{ width: "14%" }}>
        <div className="title">کل ورودی</div>
        <div className="txt">{input != "" ? addCommas(input) : "0"}</div>
      </div>
      <div className="contain-wallet" style={{ width: "14%" }}>
        <div className="title">کل خروجی</div>
        <div className="txt">{output ? addCommas(output) : "0"}</div>
      </div>
      <div className="contain-wallet" style={{ width: "8%" }}>
        <div className="title">عملیات</div>
        <div className="d-flex justify-content-center align-items-center txt">
          {main_status == "0" ? (
            <div
              className="tlg"
              onClick={() => {
                Swal.fire({
                  title: "آیا از توقف ولت مطمن هستید؟",
                  showDenyButton: true,
                  confirmButtonText: "بله",
                  denyButtonText: `خیر`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    stopHandler(walletId, walletUid);
                    console.log("stopHandlerid", walletId);

                    //navigate("/");
                    // Swal.fire("اتمام فروش باموفقت ثبت شد", "", "success");
                  } else if (result.isDenied) {
                    Swal.fire("توقف ولت لغو شد", "", "info");
                  }
                });
              }}
            >
              <h4 data-tip="مسدود کردن ولت ">
                <MdBlock className="tlg1" />
              </h4>

              <ReactTooltip />
            </div>
          ) : (
            <div
              className="tlg"
              onClick={() => {
                Swal.fire({
                  title: "آیا از فعال شدن ولت مطمن هستید؟",
                  showDenyButton: true,
                  confirmButtonText: "بله",
                  denyButtonText: `خیر`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    unblockHandler(walletId, walletUid);
                    console.log("unblocid", walletId);
                    //navigate("/");
                    // Swal.fire("اتمام فروش باموفقت ثبت شد", "", "success");
                  } else if (result.isDenied) {
                    Swal.fire("فعال شدن ولت لغو شد", "", "info");
                  }
                });
              }}
            >
              <h4 data-tip="رفع مسدودیت ولت ">
                <CgUnblock className="tlg1" />
              </h4>

              <ReactTooltip />
            </div>
          )}

          <div
            className="tlg"
            data-bs-toggle="modal"
            data-bs-target="#ReportWallet"
            onClick={() => {
              setWalletId(walletId);
              console.log("wid", walletId);
            }}
          >
            <h4 data-tip="گزارش ولت">
              <TbReportSearch className="tlg1" />
            </h4>
            <ReactTooltip />
          </div>
        </div>
      </div>
    </div>
  );
}
